import React from "react";
import { Caption1, Tooltip } from "@activecollab/components";
import classnames from "classnames";
import PropTypes from "prop-types";
import { minutesToHours } from "~/utils/utils";

export const UserWeeklyCapacity = ({ workWeekData, onClick }) => {
  return (
    <Tooltip
      title={workWeekData?.verbose_capacity}
      disable={!workWeekData?.verbose_capacity}
    >
      <div
        onClick={onClick}
        data-testid="test-work-capacity"
        className={classnames("tw-py-1 tw-ml-2 tw-rounded-2xl tw-shrink-0", {
          "tw-px-3 tw-cursor-pointer tw-bg-theme-200 hover:tw-bg-theme-300": onClick,
          "tw-cursor-help": !onClick && workWeekData?.verbose_capacity,
        })}
      >
        <Caption1
          color="tertiary"
          weight="medium"
          whitespace="no-wrap"
          lineHeight="tight"
        >
          {`${minutesToHours(workWeekData?.weekly_capacity, true)} h/w`}
        </Caption1>
      </div>
    </Tooltip>
  );
};

UserWeeklyCapacity.propTypes = {
  workWeekData: PropTypes.object,
  onClick: PropTypes.func,
};

UserWeeklyCapacity.displayName = "UserWeeklyCapacity";
